module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo-sp@2x.bab60fa6.jpg";